import { MockFactory } from '@tino-frontend/mocks'
import { BillLineDebitChargebackAggregateV4, BillLineItemV2Kind } from '@types'

export const lineItemDebtChargebackAggregateMock =
  new MockFactory<BillLineDebitChargebackAggregateV4>({
    id: 'line_item_id_aggregate_01',
    amount_cents: 40002,
    reference_date: '2023-12-01T00:00:00Z',
    payer_id: 'payer_id_01',
    kind: BillLineItemV2Kind.DebtChargebackAggregate,
    metadata: {
      chargeback_debts: [
        {
          chargeback_debt_id: 'purchase-debit-id-2',
          base_debt_id: 'base_debt_id-99',
          total_amount_cents: 20000,
          paid_amount_cents: 0,
          created_at: '2023-12-01T00:00:00Z',
          activated_at: '2022-04-10T00:00:00Z',
          due_at: '2023-12-01T00:00:00Z',
        },
        {
          chargeback_debt_id: 'purchase-debit-id-3',
          total_amount_cents: 15000,
          paid_amount_cents: 5000,
          base_debt_id: 'base_debt_id-199',
          created_at: '2023-12-01T00:00:00Z',
          activated_at: '2022-04-10T00:00:00Z',
          due_at: '2023-12-01T00:00:00Z',
        },
      ],
    },
  })
